const publicPaths = new Set(["/", "/login", "/activate", "/auth/callback", "/subscription"]);

export function isPublicAppPath(pathname: string): boolean {
  return publicPaths.has(pathname);
}
